import type { AccountType } from '@application/types';
import type { CardItemBreederData } from '@presentation/components';
import type { CardData } from './components/Card/types';

export interface MtApplicationsPageData {
  title: string;
  emptyTitle: string;
  emptyText?: string;
  topCards?: CardData[];
  cards: CardData[];
  loading: boolean;
  columnTitles: [string, string, string, string];
  personType: AccountType;
  showArchived: boolean;
  breederItems?: CardItemBreederData[];
  onToggleShowArchived: ((value: boolean) => void) | null;
  onOpenSuggestionsModal?: () => void;
}

export interface MtApplicationsPageProps extends MtApplicationsPageData {}
